import routes from '@/modules/video/video-routes';

export default {
  routes,
};